import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { IDecayCalibrationType } from '@models/decay/decay-calibration-type';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DecayCalibrationTypeService {
  private _decayCalibrationTypes: IDecayCalibrationType[];
  private calibrationEndpoint: string;
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    this.appConfig.environment.subscribe(env => {
      this.calibrationEndpoint = `${env.API.DECAY}/api/decay/calibration`;
    });
  }

  public getDecayCalibrationTypes() {
    if (this._decayCalibrationTypes) {
      return of(this._decayCalibrationTypes);
    }
    return this.http.get<IDecayCalibrationType[]>(`${this.calibrationEndpoint}/type`).pipe(tap(res => (this._decayCalibrationTypes = res)));
  }
}
